module.exports = __webpack_public_path__ + "static/media/tanabxazindagi-event-01.146b7fc4.png";